import { Grid2 } from "@mui/material"
import CustomAccordion from "../../../../components/ui/materialui/customAccordion"
import { TasaTablaForm } from "../models/tasaTablaForm"
import { selectorTransversalNumerico } from "../../../../dtos/selector"
import { Control, FieldErrors, UseFormReset, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useEffect } from "react"
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect"
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha"
import InputSwitch from "../../../../components/inputs/yup/materialui/inputSwitch"

interface IProps {
    datosTabla: TasaTablaForm,
    control: Control<TasaTablaForm, any>
    watch: UseFormWatch<TasaTablaForm>
    reset: UseFormReset<TasaTablaForm>
    errors: FieldErrors<TasaTablaForm>
    setValue: UseFormSetValue<TasaTablaForm>
}

export const DatosTableForm = ({datosTabla, control, watch, reset, errors, setValue} : IProps) => {

    const opcionesTasa : selectorTransversalNumerico[] = [
        {label: "360", value: 360},
        {label: "365", value: 365}, 
    ]

    const watcher = watch();

    useEffect(() => {
        reset(datosTabla)
    }, [])

    useEffect(() => {
        if (watcher.tasa !== 365){
            setValue("fechaEscrituracion", new Date())
        }
    }, [watcher.tasa])

    return (
        <CustomAccordion
            title='Datos tabla'
            expandedDefault
        >
            <Grid2 container spacing={2} sx={{ marginTop: 1, alignItems: "center" }}>
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputSelect
                        label="Tasa"
                        name={'tasa'}
                        control={control}
                        options={opcionesTasa}
                        error={errors.tasa}
                    />
                </Grid2>
                { watcher.tasa === 365 ?
                    <Grid2 size={{ xs: 12, lg: 4 }}>
                        <InputFecha 
                            name="fechaEscrituracion"
                            control={control}
                            label="Fecha de escrituración"
                            error={errors.fechaEscrituracion}
                            fecha={watcher.fechaEscrituracion}
                        />
                    </Grid2> : <></>
                }          
                <Grid2 size={{ xs: 12, lg: 4 }}>
                    <InputSwitch
                        name="conDescuento"
                        control={control}
                        label="Aplicar descuentos proporcional"
                        error={errors.conDescuento}
                    />
                </Grid2>
            </Grid2>
        </CustomAccordion>
    )
}